import { FC, CSSProperties } from 'react';
import { Tooltip, Typography, useTheme } from '@material-ui/core';
import { IconLabelBox } from '../../IconLabelBox';
import { KoFilledIcon } from './Icons';
import { useStyles } from './style';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const NotExecutedIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Tooltip title="Failed. You need to solve the errors reported since they will prevent the deployment">
      <span>
        {variant === 'reduced' ? (
          <KoFilledIcon
            htmlColor={theme.palette.error.main}
            className={classes.icon}
            style={style}
          />
        ) : (
          <IconLabelBox
            label="Not Executed"
            backgroundColor={theme.palette.error.main}
            icon={
              <Typography
                variant="body2"
                style={{
                  color: theme.palette.black,
                  fontWeight: '700',
                }}
              >
                KO
              </Typography>
            }
          />
        )}
      </span>
    </Tooltip>
  );
};
